module.exports = __webpack_public_path__ + "img/corner-joint-inner.affb7aff.svg";